import { createWebHashHistory, createRouter } from "vue-router";
import Home from "./components/Home.vue";
import Login from "./components/Login.vue";
import Register from "./components/Register.vue";
import RegisterSuccess from "./components/RegisterSuccess.vue";
// import Test from "./components/test.vue";
import ForgotPassword from "./components/ForgotPassword.vue";
import ResetPasswordEmail from "./components/reset.vue";
import UserService from './services/user.service'
// lazy-loaded
const Analyzer = () => import("./components/Analyzer.vue")
const Profile = () => import("./components/Profile.vue")



const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/account-confirm-email/:id",
    name: "account-confirm-email",
    component: () => import("./components/account-confirm-email.vue")
  },
  {
    path: "/home",
    component: Home,
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/register",
    component: Register,
  },

  {
    path: "/forgotpassword",
    component: ForgotPassword,
  },
  {
    path: "/reset/:uid/:resetToken",
    component: ResetPasswordEmail,
  },
  {
    path: "/registersuccess",
    component: RegisterSuccess,
  },
  {
    path: "/analyzer",
    name: "analyzer",
    // lazy-loaded
    component: Analyzer,
    beforeEnter: (to, from, next) => {
      const loggedIn = localStorage.getItem('user');
      if (!loggedIn) {
        next('/login');
      } else {
        let loginSurveyID = "SV_3wwyYpVR2MUYiWO"
        let RegisterSurveyID = "SV_86XAqAqFqsAPQWy"
        UserService.getSurveyID(RegisterSurveyID).then((res) => {
          if (res.data.response_id === "No record")
          {
            UserService.getSurveyID(loginSurveyID).then((res) => {
              if (res.data.response_id === "No record"){
                window.location.href = "https://eduhk.au1.qualtrics.com/jfe/form/SV_3wwyYpVR2MUYiWO"
              }
              else {
                next();
              }
            })
          }
          else{
            next();
          }
        })
      }
    }
  },
  {
    path: "/profile",
    name: "profile",
    // lazy-loaded
    component: Profile,
    beforeEnter: (to, from, next) => {
      const loggedIn = localStorage.getItem('user');
      if (!loggedIn) {
        next('/login');
      } else {
        next();
      }
    }
  },

  {
    path: "/survey/:survey_id/:response_id",
    name: "survey",
    component: () => import("./components/Survey.vue")
  },

  {
    path: "/test/:survey_id/:response_id",
    name: "test",
    component: () => import("./components/test.vue")
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// router.beforeEach((to, from, next) => {
//   const publicPages = ['/login', '/register', '/home', '/account-confirm-email/:id','/registersuccess'];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem('user');

//   // trying to access a restricted page + not logged in
//   // redirect to login page
//   if (authRequired && !loggedIn) {
//     next('/login');
//   } else {
//     next();
//   }
// });

export default router;